import { render } from "./AddChapter.vue?vue&type=template&id=63eefbc4"
import script from "./AddChapter.vue?vue&type=script&lang=js"
export * from "./AddChapter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__